module.exports = __webpack_public_path__ + "img/w-direct-mail.6a8d7913.svg";